module.exports = __webpack_public_path__ + "static/media/lock_black_24dp.f302c288.svg";